import React from 'react';
import { Tile } from 'carbon-components-react';

interface StripePaymentCardProps {
  amount: string;
  currency: string;
  description: string;
}

const StripePaymentCard: React.FC<StripePaymentCardProps> = ({
  amount,
  currency,
  description
}) => {
  return (
    <Tile className="stripe-payment-card">
      <div className="stripe-payment-card__amount">
        {amount} {currency.toUpperCase()}
      </div>
      <div className="stripe-payment-card__description">{description}</div>
    </Tile>
  );
};

export default StripePaymentCard;
